var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDLibra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.003,
    height: 20.033,
    viewBox: "0 0 56.003 20.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    transform: "translate(-4.185 -4.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inteligentne_obiekty_wektorowe",
    transform: "translate(4.185 4.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M-23.743-20.821a5,5,0,0,1,2.322.573v2.23A3.236,3.236,0,0,0-26-18.083a3.236,3.236,0,0,0-.066,4.576,3.236,3.236,0,0,0,4.576.066,3.236,3.236,0,0,0,.981-2.323v-3.873h0v-4.917h1.818v8.922h-.005a5.055,5.055,0,0,1-5.187,4.92A5.055,5.055,0,0,1-28.8-15.9,5.055,5.055,0,0,1-23.743-20.821Z",
    transform: "translate(28.801 24.554)",
    fill: "#343d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M1.154-14.245a3.237,3.237,0,0,1-4.378,1.339,3.237,3.237,0,0,1-1.718-2.859v-3.872h0v-4.917H-6.761v8.922h0a5.048,5.048,0,0,0,5.085,5.011,5.048,5.048,0,0,0,4.806-3.624Z",
    transform: "translate(19.3 24.554)",
    fill: "#343d44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    transform: "translate(3.004 15.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M-11.933-18.584h.129A.887.887,0,0,1-11.933-18.584Z",
    transform: "translate(21.904 23.167)",
    fill: "#208ff3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M-24.41-25.8l.423.936c.8,1.511,1.792,1.71,2.141,1.731h-5.069a2.769,2.769,0,0,1-2.113-1.73l-.426-.936s-.745-1.92-2.362-1.92h5.047C-25.154-27.721-24.41-25.8-24.41-25.8Z",
    transform: "translate(31.816 27.722)",
    fill: "#208ff3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(8.889 15.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M-31.686-18.581h-.129A1,1,0,0,0-31.686-18.581Z",
    transform: "translate(31.815 23.165)",
    fill: "#0c61a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M-28.991-25.8l-.425.934c-.8,1.511-1.792,1.709-2.141,1.731h5.072a2.769,2.769,0,0,0,2.113-1.73l.423-.934s.745-1.919,2.362-1.919h-5.045C-28.247-27.721-28.991-25.8-28.991-25.8Z",
    transform: "translate(31.686 27.721)",
    fill: "#0c61a5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M-7.986,11.721h-5.2a2.181,2.181,0,0,0,1.748-.941,5.138,5.138,0,0,0,.505-.757c.137-.3.384-.84.384-.84l.316.7s.752,1.7,2.162,1.844",
    transform: "translate(21.961 8.277)",
    fill: "#0d5075"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    width: 1.82,
    height: 9.844,
    transform: "translate(24.198 4)",
    fill: "#343d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M25.265-20.817a5,5,0,0,0-2.325.574v2.232a3.24,3.24,0,0,1,4.581-.066,3.24,3.24,0,0,1,.066,4.581,3.24,3.24,0,0,1-4.581.066,3.24,3.24,0,0,1-.982-2.324v-3.878h0v-4.922H20.2v8.931h0A5.06,5.06,0,0,0,25.4-10.7a5.06,5.06,0,0,0,4.925-5.192,5.06,5.06,0,0,0-5.06-4.926Z",
    transform: "translate(7.695 24.554)",
    fill: "#343d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M47.122-17.5a5.084,5.084,0,0,0-5.106,5.062h0V-7.1h1.909v-5.336a3.24,3.24,0,0,1,3.2-3.239Z",
    transform: "translate(-2.23 21.247)",
    fill: "#343d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M61.9-11.962a5.061,5.061,0,0,0-5.149-4.972,5.061,5.061,0,0,0-4.972,5.149,5.061,5.061,0,0,0,5.06,4.973A5,5,0,0,0,59.1-7.346V-9.636a3.239,3.239,0,0,1-4.58-.077,3.239,3.239,0,0,1,.077-4.58,3.239,3.239,0,0,1,4.58.077,3.239,3.239,0,0,1,.911,2.254c0,.079-.006.155-.012.233v3.744l.012-.009v1h1.821v-4.965Z",
    transform: "translate(-5.905 20.977)",
    fill: "#343d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M16.592-23.287a1.06,1.06,0,0,1-1.06,1.06,1.06,1.06,0,0,1-1.06-1.06,1.06,1.06,0,0,1,1.06-1.06h0A1.06,1.06,0,0,1,16.592-23.287Z",
    transform: "translate(9.542 24.314)",
    fill: "#343d44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDLibra);
export default __webpack_public_path__ + "static/media/dLibra.e32f058b9a17f7e70d30c0fbca5f5f54.svg";
export { ForwardRef as ReactComponent };